// extracted by mini-css-extract-plugin
export default {"header":"header_header__MhatS","alert":"header_alert__xahm0","alertText":"header_alertText__gMY+0"};